// extracted by mini-css-extract-plugin
export var backupIcon = "_op-1";
export var image = "_op-0";